import src from "IMAGE";
export default { src, width: 77, height: 24, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AIGAgGdDQkEvXVtaQV1cWkRWVVU+S0pOOVVWXUZTVWFFAISEhGdUU1I8oZ+dfKyppoWdm5x1paWrhoOFkWaSlKZ6HMMbiPqKaPcAAAAASUVORK5CYII="};
